import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, NonRequired } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const MarktausblickForschungAntragEmobFundE: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Marktausblick und Verwertung' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0149595523_wertung_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0119161730_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0121048317_ng_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0074775636_Verwertung_Pruefung_Erledigt.path
				}
				formStruc={formStrucPruefAssistenz()}
			/>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default MarktausblickForschungAntragEmobFundE;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0074775636_Verwertung_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0133967662_ial_Marktgroesse_Zielgruppen,
					label: 'Wirtschaftliches Potenzial / Marktgröße / Zielgruppe(n) - Beschreibung',
				},
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0139433634_sblick_Und_Verwertung_Bilder,
					tableLabel: 'Bildmaterial zu Erläuterung des wirtschaftlichen Potenzials / Marktgröße / Zielgruppe (optional)',
					type: FORM_FIELDS_TYPES.editableTable,
					fieldProps: { Bild: { allowOnlyImage: true } },
				},
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0198788702_urrenztechnologien_Barrieren,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0051505604_amtsystems_Elektromobilitaet,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0253442154_inderung_Ressourceneffizienz,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0152179886_e_Akteure_In_Andere_Branchen,
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0094054709_lick_Und_Verwertung_Anhaenge,
					allowOnlyImage: true,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucMarktausblickForschungAntragEmobFundE = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0149595523_wertung_Pruefung_Pruefstatus.path,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0074775636_Verwertung_Pruefung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	else return concat(formStruc());
};
